import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORT_TITLES = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_SELECT_REPORTS.GET_REPORT_TITLES"
);

export const GET_SSWP_CONFIGS = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_SELECT_REPORTS.GET_SSWP_CONFIGS"
);

export const GET_HSQE_CONFIGS = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_SELECT_REPORTS.GET_HSQE_CONFIGS"
);
